import moment from 'moment';

export default {
    filters: {
        formatPrice: x => `CHF ${x.toLocaleString('de-CH')}`,
        round: x => (Math.round(x * 20) / 20).toFixed(2),
        simpleFormatPrice: x => `${x.toFixed(2)} CHF`,
        formatDate: (date, format) => moment(date).format(format),
    },
};



// WEBPACK FOOTER //
// ./static/js/Order/mixins/filters.js